:host {
  --loader-color: var(--pine-color-brand);
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: var(--pine-dimension-xs);
}


:host(.pds-loader--hidden),
.pds-loader--hidden {
  border-width: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

// Default Loader
.pds-loader--spinner svg {
  --number-spinner-timing: 2s;
  --number-spinner-path-timing: 1.5s;

  animation: rotate var(--number-spinner-timing) linear infinite;
  color: var(--loader-color);
}

.pds-loader__spinner-path {
  stroke-width: 8px;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

// Typing Loader
.pds-loader--typing {
  --number-typing-timing: 1s;

  --opacity-typing-dot-default: 0.4;
  --opacity-typing-dot-active: 1;

  align-items: center;
  background-color: var(--pine-color-background-container-disabled);
  border-radius: var(--pine-dimension-sm);
  box-shadow: var(--pine-box-shadow);
  display: inline-flex;
  gap: var(--pine-dimension-2xs);
  margin-block: var(--pine-dimension-none);
  margin-inline: auto;
  padding-block: 15px;
  padding-inline: 20px;
  position: relative;

  span {
    background-color: var(--pine-color-border-hover);
    block-size: 6px;
    border-radius: var(--pine-border-radius-full);
    inline-size: 6px;
    opacity: var(--opacity-typing-dot-default);

    @for $i from 1 through 3 {
      &:nth-of-type(#{$i}) {
        animation: var(--number-typing-timing) typing infinite ($i * 0.3333s);
      }
    }
  }
}

@keyframes typing {
  50% {
    opacity: var(--opacity-typing-dot-active);
    transform: scale(1.25);
  }
}

.pds-loader__label {
  --typography-label-default: var(--pine-font-weight-medium) var(--pine-font-size-body-md)/var(--pine-line-height-body) var(--pine-font-family-body);

  font: var(--typography-label-default);
}
